import { render, staticRenderFns } from "./StageStream.vue?vue&type=template&id=47af98ce&scoped=true&"
import script from "./StageStream.vue?vue&type=script&lang=js&"
export * from "./StageStream.vue?vue&type=script&lang=js&"
import style0 from "./StageStream.vue?vue&type=style&index=0&id=47af98ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47af98ce",
  null
  
)

export default component.exports